"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsiteTypography = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const websiteTypographyMixin_1 = require("./websiteTypographyMixin");
exports.WebsiteTypography = styled_components_1.default.div `
  ${({ size, kind, type }) => (0, websiteTypographyMixin_1.websiteTypographyMixin)(kind, size, type)}
`;
//# sourceMappingURL=WebsiteTypography.js.map